export var POST_MESSAGE_TYPES;
(function (POST_MESSAGE_TYPES) {
    POST_MESSAGE_TYPES["FRAME_CLOSE"] = "MEDIA_IMAGE_STUDIO.FRAME_CLOSE";
    POST_MESSAGE_TYPES["IMAGE_DATA"] = "MEDIA_IMAGE_STUDIO.IMAGE_DATA";
    POST_MESSAGE_TYPES["UPLOADED_IMAGE"] = "MEDIA_IMAGE_STUDIO.UPLOADED_IMAGE";
    POST_MESSAGE_TYPES["UPLOADED_IMAGE_FAILED"] = "MEDIA_IMAGE_STUDIO.UPLOADED_IMAGE_FAILED";
    POST_MESSAGE_TYPES["READY"] = "MEDIA_IMAGE_STUDIO.READY";
})(POST_MESSAGE_TYPES || (POST_MESSAGE_TYPES = {}));
//# sourceMappingURL=outcomingMessages.types.js.map